import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetSystemDetailsQueryVariables = Types.Exact<{
  propertyId: Types.Scalars['uuid']['input'];
  categoryId: Types.Scalars['uuid']['input'];
}>;


export type GetSystemDetailsQuery = { __typename?: 'query_root', proof_center_categories_by_pk?: { __typename?: 'proof_center_categories', id: any, name: string, key?: string | null, importance?: string | null, proof_center_category_requirements: Array<{ __typename?: 'proof_center_category_requirements', id: any, name: string, description?: string | null, proof_center_property_category_requirements: Array<{ __typename?: 'proof_center_property_category_requirements', id: any, is_completed: boolean }> }> } | null, inspections_reports: Array<{ __typename?: 'inspections_reports', id: any, name: string, description?: string | null, created_at: any }> };


export const GetSystemDetailsDocument = gql`
    query getSystemDetails($propertyId: uuid!, $categoryId: uuid!) {
  proof_center_categories_by_pk(id: $categoryId) {
    id
    name
    key
    importance
    proof_center_category_requirements {
      id
      name
      description
      proof_center_property_category_requirements(
        where: {property_id: {_eq: $propertyId}}
      ) {
        id
        is_completed
      }
    }
  }
  inspections_reports(where: {property_id: {_eq: $propertyId}}) {
    id
    name
    description
    created_at
  }
}
    `;

/**
 * __useGetSystemDetailsQuery__
 *
 * To run a query within a React component, call `useGetSystemDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSystemDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSystemDetailsQuery({
 *   variables: {
 *      propertyId: // value for 'propertyId'
 *      categoryId: // value for 'categoryId'
 *   },
 * });
 */
export function useGetSystemDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetSystemDetailsQuery, GetSystemDetailsQueryVariables> & ({ variables: GetSystemDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSystemDetailsQuery, GetSystemDetailsQueryVariables>(GetSystemDetailsDocument, options);
      }
export function useGetSystemDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSystemDetailsQuery, GetSystemDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSystemDetailsQuery, GetSystemDetailsQueryVariables>(GetSystemDetailsDocument, options);
        }
export function useGetSystemDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSystemDetailsQuery, GetSystemDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSystemDetailsQuery, GetSystemDetailsQueryVariables>(GetSystemDetailsDocument, options);
        }
export type GetSystemDetailsQueryHookResult = ReturnType<typeof useGetSystemDetailsQuery>;
export type GetSystemDetailsLazyQueryHookResult = ReturnType<typeof useGetSystemDetailsLazyQuery>;
export type GetSystemDetailsSuspenseQueryHookResult = ReturnType<typeof useGetSystemDetailsSuspenseQuery>;
export type GetSystemDetailsQueryResult = Apollo.QueryResult<GetSystemDetailsQuery, GetSystemDetailsQueryVariables>;